import React, {useEffect, useState} from 'react';
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {Button, Card, Form, Input, message, Modal} from "antd";
import {useNavigate} from "react-router-dom";
import copy from "copy-to-clipboard";

import { AiOutlineCopy } from "react-icons/ai"

const Project_setting=()=>{

    const navigate=useNavigate();

    document.title='设置'
    let data_time=dayjs().unix();

    function formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 B';

        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }


    useEffect(() => {
        const usecookie = () => {




            switch (Cookies.get('userToken_chattool')) {

                case undefined:

                    navigate('/projectlogin?return_url=/project/setting')


                    break;

                default:

                    // setupdate_password_modal_onfinish_select_log({message:'',value:'',time:0})
                    window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部
                    break;


            }


        }

        usecookie();
    }, []); // 空数组表示仅在组件挂载时执行





    const [update_password_modal_open, setupdate_password_modal_open] = useState(false)

    const [update_password_select_info, setupdate_password_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [update_password_select_log, setupdate_password_select_log] = useState({message: '', value: '', time: 0})
    const update_password = (e1: any) => {

        setupdate_password_select_log({message: 'click', value: '', time: data_time})

        setupdate_password_modal_open(true);

        setupdate_password_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setupdate_password_modal_oncancel = () => {

        setupdate_password_modal_open(false);
    }


    const [update_password_modal_form]=Form.useForm();

    const update_password_modal_initialValues={




    }

    const [update_password_modal_onfinish_select_log,setupdate_password_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [update_password_modal_onfinish_select_info,setupdate_password_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const update_password_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setupdate_password_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setupdate_password_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_update_password,setreturn_data_update_password]=useState({});

    const update_password_body = new FormData();


    update_password_body.append('finish_data', JSON.stringify(update_password_modal_onfinish_select_info.value1));

    update_password_body.append('userToken', String(Cookies.get('userToken_chattool')));

    update_password_body.append('time', String(update_password_modal_onfinish_select_info.time));

    update_password_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/project/update/update_project_paw.php', {


                method: 'POST',
                body: update_password_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setupdate_password_modal_open(false)

                    setreturn_data_update_password(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/projectlogin?return_url=/project/setting')


                    break


            }

        }


        if(update_password_modal_onfinish_select_log.message!==''){

            data_async();
            setupdate_password_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [update_password_modal_onfinish_select_log]);







    const copy_text=(e1:any)=>{


        message.success('复制成功')

        copy(e1)


    }
    return(<div>




        <Card title={'修改密码'}>

            <Button onClick={update_password}>修改</Button>

        </Card>











        <Modal open={update_password_modal_open} onCancel={setupdate_password_modal_oncancel} footer={null} title={'设置密码'}>




            <Form form={update_password_modal_form} initialValues={update_password_modal_initialValues} onFinish={update_password_modal_onfinish}>

                <label>旧密码</label>

                <Form.Item name={'input_value1'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>新密码</label>

                <Form.Item name={'input_value2'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>再次输入新密码</label>

                <Form.Item name={'input_value3'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft:10}} onClick={setupdate_password_modal_oncancel}>取消</Button>

            </Form>


        </Modal>








    </div>)}

export default Project_setting;
